import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {HOTB} from "../HOTB";
import {gsap} from "gsap";
import {GameUtils} from "../utils/GameUtils";

export class SatanSpinView extends PIXI.Container implements StageLayer {
    constructor() {
        super();
        this.name = "SatanSpinView";
    }

    public onSpinStart(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            doorsOpenDur: number = HOTB.gameForeground.getDoorsAnimDur("mg_doorOpen");

        GameUtils.toggleSymbols(true);
        HOTB.soundPlayer.fadeMusic(0,0.01);
        HOTB.soundPlayer.playSatanSpinSounds();

        tl.to(this, {
            duration: doorsOpenDur,
            onStart: (): void => {
                this.hideBBIntro();
            }
        });

        return tl;
    }

    public showBBIntro(forceHideSymbols: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(HOTB.reelArea.toggleSatanSymbol(true));

        tl.add((): void => {
            if (forceHideSymbols) {
                GameUtils.toggleSymbols(false);
            }
        });

        return tl;
    }

    public hideBBIntro(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(HOTB.reelArea.toggleSatanSymbol(false));

        return tl;
    }
}